import React, { useEffect } from 'react';

import BindDataToComponents from "vagaro-website-rendering/src/components/Binding/BindDataToComponents"
import { utils } from 'vagaro-website-rendering/src/utils/Utils';
import {Site} from "../Utils/Utils"
import { AnimateDoms } from 'vagaro-website-rendering/src/components/Binding/ScreenStateHandler';
import  BindGrouping  from 'vagaro-website-rendering/src/components/Binding/BindGrouping';
import "../assets/js/WebsiteBuilder/VagaroConnect.js"

export function PostRenderBindings (props:any) {

    document.body.style.overflow = "";//restet overflow before other functions/renders can be called


    useEffect(() => {

        const encDom = document.getElementById("vwbeid")  as HTMLInputElement;
        const siteEncDom = document.getElementById("vwsbeid")  as HTMLInputElement;
        const encHashDom = document.getElementById("vwbeidhash")  as HTMLInputElement;
        const mysiteDom = document.getElementById('vwbisms')  as HTMLInputElement;
        const vgurlDom = document.getElementById('vgurl') as HTMLInputElement;
        const isDupDom = document.getElementById('vwdplic') as HTMLInputElement;
        const aliasDom = document.getElementById('vwbalias') as HTMLInputElement;
        const nicknameDom = document.getElementById('vwbnickname') as HTMLInputElement;
        const isshoppingcart = document.getElementById('vwisshoppingcart') as HTMLInputElement;
        const websiteNameDom = document.getElementById('vwbwebsitename') as HTMLInputElement;
        const telePhoneDom = document.getElementById('vwbtelephone') as HTMLInputElement;

        if (window._vagaroConnect !== undefined) {
            window._vagaroConnect.CustomerWithoutLoginData(props.multilocationdata);
        }
        const fadeOut = ()=>{

            //call mysiteloaded event for any external scripts
            const myEvent = new Event("mysiteloaded");
            window.dispatchEvent(myEvent);
            //since the fade in uses a css var that may not be loaded there is a fallback layer that is pure white. remove this when we begin to fade in.
            let fallbackDom = document.getElementById("fade-in-fallback") as HTMLElement;
            if(fallbackDom){
                fallbackDom.style.display = "none";
            }



            let fadeDom = document.getElementById("fade-in-cover") as HTMLElement;
            if(fadeDom){
                fadeDom.style.opacity = "0";

                fadeDom.style.pointerEvents = "none";//make sure does not block clicks
                setTimeout(() => {
                    fadeDom.style.display = "none";
                },1000);
            }

            AnimateDoms();//animate all animations AFTER we start fading out the loader

        }

        const fadeIn = ()=>{

            let active = document.activeElement;

            if(active&&active.tagName==="A"){ // check if the active element is a link that isn't actually redirecting the page..
                let href = active.getAttribute("href");

                if(href?.startsWith("tel:")||href?.startsWith("mailto:")||href?.startsWith("sms:")||href?.startsWith("whatsapp:")){
                    return;
                }
            }

            let fadeDom = document.getElementById("fade-in-cover");
            if(fadeDom){
                fadeDom.style.display="flex"
                document.body.style.overflow = "hidden";
                fadeDom.style.pointerEvents = "all";//block mouse clicks
                fadeDom.classList.add("vanimation-fade-in");
            }


        }

        //window.addEventListener("beforeunload", fadeIn);

        BindGrouping();

        const vgURL = vgurlDom?.value??"";
        const bid = encDom?.value??"";
        const bidHash = encHashDom?.value??"";
        const siteBid = siteEncDom?.value??"";
        const isDuplicated = isDupDom?.value == "true";
        const isShoppingCart = (isshoppingcart!=null && isshoppingcart?.value == "true") ? true : false;
        const aliasName = aliasDom?.value ?? "";
        const nickname = nicknameDom?.value ?? "";
        const websitename = websiteNameDom?.value ?? "";
        const telephone = telePhoneDom?.value ?? "";

        if(encDom&&mysiteDom&&siteEncDom){

            let mySiteValue = mysiteDom.value;

            //BindDataToComponents(bid,props.access_token,bid,props.multilocationdata,props.accessgenerationtime + 40 * 60000,vgURL,(mySiteValue==="true"),fadeOut);
            BindDataToComponents(bid,
                props.access_token,
                props.multilocationdata,
                bidHash,props.accessgenerationtime + 40 * 60000,
                (mySiteValue==="true"),
                fadeOut, vgURL, isDuplicated, siteBid, nickname, isShoppingCart, websitename, telephone
                );
        }

        let path = window.location.href;




        let shoppingBag = path.indexOf("/shopping-bag");
        let myAccount = path.indexOf("/myaccount");
        if (shoppingBag >= 0) {
            var widgetCookieString = "";
            var vsdId = localStorage.getItem("vdsid")
            if (vsdId != null && vsdId != '' && vsdId != undefined) {
                widgetCookieString = "&wgVal=" + vsdId;
            }
            window.wbc.openVagaroPage("divVagaroIframe", Site.SiteName + vgURL + "/shopping-bag?Type=Builder&Event=ShoppingBag" + widgetCookieString)
        }
        if (myAccount >= 0) {
            var widgetCookieString = "";
            var vsdId = localStorage.getItem("vdsid")
            if (vsdId != null && vsdId != '' && vsdId != undefined) {
                widgetCookieString = "&wgVal=" + vsdId;
            }
            window.wbc.openVagaroPage("divVagaroIframe", utils.VURL(null, null, "myaccount") + "&encData=" + bid + widgetCookieString);
        }


    }, [])

    return <></>
}
